import React from 'react';

const MARK_URL = `${process.env.PUBLIC_URL || ''}/brand/sinatra-mark.svg`;

// Sinatra tile mark (public/brand/sinatra-mark.svg): 3x3 mosaic in the Tileward palette
export function SinatraMark({ size = 22 }) {
  return (
    <img
      className="sinatra-brand__mark"
      src={MARK_URL}
      width={Math.round(size * 316 / 234)}
      height={size}
      alt=""
    />
  );
}

// Just the company/product name, no mark - for places the mark already appears next to (the
// header, beside the Sidebar's own icon at the top of the nav rail). Takes its size from the
// font size around it.
export function SinatraWordmark() {
  return (
    <span className="sinatra-brand__words">
      <span className="sinatra-brand__company">Tile<span className="sinatra-brand__ward">ward</span></span>
      <span className="sinatra-brand__product">Sinatra</span>
    </span>
  );
}

// The Tileward lockup: the mark beside the company's name, with the product under it.
export default function SinatraLogo({ markSize = 32 }) {
  return (
    <span className="sinatra-brand">
      <SinatraMark size={markSize} />
      <SinatraWordmark />
    </span>
  );
}
